import { DEFAULT_LANG } from '@fides/fides-react-components';
import { setDefaultOptions } from 'date-fns';
import {
  DateFormat,
  FirstDayOfWeekValue,
  JsonObject,
  KeepDownloadCenter,
  LanguageValue,
  NumberFormatSeparator,
  PaymentScreenLayoutValue,
} from '../types';
import { EXPORT_TYPE } from './ARS/ExportType';
import { GridSettings } from './GridSettings';
import { PaymentSettings } from './PaymentSettings';

export const DEFAULT_DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const CONVERSION_MAP = {
  DOT_APOSTROPHE: 'de-ch',
  DOT_COMMA: 'en-us',
  COMMA_DOT: 'de-de',
  COMMA_SPACE: 'fr-fr',

  FRANCE_SPAIN_UNITED_KINGDOM: DEFAULT_DATE_TIME_FORMAT,
  AUSTRIA_GERMANY_SWITZERLAND: 'DD.MM.YYYY HH:mm:ss',
  UNITED_STATES: 'MM/DD/YYYY hh:mm:ss a',
  SETTINGS_EXPORTDELIMITER_OPTION_COMMA: ',',
  SETTINGS_EXPORTDELIMITER_OPTION_SEMICOLON: ';',
  SETTINGS_EXPORTDELIMITER_OPTION_TAB: '\t',
  SETTINGS_EXPORTDELIMITER_OPTION_PIPE: '|',
  SETTINGS_EXPORTDELIMITER_OPTION_EXCLAMATION: '!',
  SETTINGS_EXPORTFORMAT_OPTION_NONE: '',
  SETTINGS_EXPORTFORMAT_OPTION_CSV: EXPORT_TYPE.CSV.value,
  SETTINGS_EXPORTFORMAT_OPTION_XLS: EXPORT_TYPE.XLSX.value,
};

export const DEFAULT_CURRENCY = { code: 'CHF', fractionDigits: 2 };

export class PersonalSettings {
  public language: LanguageValue;
  public firstDayOfWeek: FirstDayOfWeekValue;
  public dateFormat: DateFormat;
  public dateFormatConverted: string;
  public formatForTime: string;
  public formatForDate: string;
  public numberFormat: NumberFormatSeparator;
  public numberFormatConverted: (typeof CONVERSION_MAP)[keyof typeof CONVERSION_MAP];
  public consolidatedCurrency: any;
  public paymentScreenLayout: PaymentScreenLayoutValue;
  public keepDownloadCenter: KeepDownloadCenter;
  public payment: PaymentSettings;
  public grids: GridSettings[];

  constructor(json?: JsonObject) {
    this.language = json?.language ? json.language : DEFAULT_LANG;
    this.firstDayOfWeek = json?.calendarStartingDay !== null ? json.calendarStartingDay : 0;
    setDefaultOptions({ weekStartsOn: this.firstDayOfWeek });
    this.dateFormat = json?.dateEnum ? json.dateEnum : 'FRANCE_SPAIN_UNITED_KINGDOM';
    this.dateFormatConverted = CONVERSION_MAP[this.dateFormat];
    const spaceIndex = this.dateFormatConverted.indexOf(' ');
    if (spaceIndex > 0) {
      this.formatForDate = this.dateFormatConverted.substr(0, spaceIndex);
      this.formatForTime = this.dateFormatConverted.substr(spaceIndex, this.dateFormatConverted.length);
    }
    this.numberFormat = json?.numberFormat ? json.numberFormat : 'COMMA_DOT';
    this.numberFormatConverted = CONVERSION_MAP[this.numberFormat];
    this.consolidatedCurrency = json?.consolidationCurrency
      ? { code: json.consolidationCurrency.code, fractionDigits: json.consolidationCurrency.fractionDigits }
      : DEFAULT_CURRENCY;
    this.paymentScreenLayout = json?.paymentScreenLayout ? json.paymentScreenLayout : 'DEFAULT_LAYOUT';
    this.keepDownloadCenter = json?.keepDownloadCenter !== null ? json.keepDownloadCenter : false;
    this.payment = { valuesFromTemplate: json?.paymentValuesFromTemplate, templates: json?.paymentTemplates };

    this.grids =
      json?.gridSettings?.map((grid: JsonObject) => ({
        columns: grid.columns,
        created: grid.created,
        deleted: grid.deleted,
        filterState: grid.filterState,
        forceDelete: grid.forceDelete,
        lastChanged: grid.lastChanged,
        gridName: grid.gridName,
        pagination: grid.pagination,
        uniqueId: grid.uniqueId,
        version: grid.version,
      })) || [];
  }
}
